import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import axios from "axios"; // 引入axios
import "@/assets/styles/global.scss"; // 引入全局css文件
import VueLazyload from "vue-lazyload"; // 引入图片懒加载

// createApp(App).use(store).use(router).mount('#app')
// app实例    use函数必须在mount函数之前调用
const app = createApp(App);
app.use(router);
app.use(ElementPlus);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 图片懒加载  配置参数
// app.use(VueLazyload, {
//   lazyComponent: true, // 开启lazyload懒加载组件
//   observer: true, // 开启 IntersectionObserver 监听器
//   // 用于在图片加载完成之前占位显示
//   loading: require("@/assets/images/loading.png"),
//   // 图片加载失败的占位图片
//   error: require("@/assets/images/error.png"),
// });
app.use(VueLazyload, {
  lazyComponent: true, // 开启lazyload懒加载组件
  observer: true, // 开启 IntersectionObserver 监听器
  loading: require("@/assets/images/loading.png"), // 用于在图片加载完成之前占位显示
  error: require("@/assets/images/error.png"), // 图片加载失败的占位图片
  adapter: {
    loading({ el }: { el: HTMLElement }) {
      el.classList.add("loading-image"); // 给图片元素添加了 `loading-image` 类，从而触发旋转动画。
    },
    loaded({ el }: { el: HTMLElement }) {
      el.classList.remove("loading-image"); // 从图片元素上移除了 `loading-image` 类，停止动画。
    },
    error({ el }: { el: HTMLElement }) {
      el.classList.remove("loading-image");
    },
  },
});

// 挂载全局对象
app.config.globalProperties.$axios = axios;

app.mount("#app");
